export const paysMDM = [
    { id: "001", label: "FRANCE", code: "FR" },
    { id: "007", label: "IRLANDE", code: "IE" },
    { id: "017", label: "BELGIQUE", code: "BE" },
    { id: "003", label: "PAYS-BAS", code: "NL" },
    { id: "004", label: "ALLEMAGNE", code: "DE" },
    { id: "018", label: "LUXEMBOURG", code: "LU" },
    { id: "005", label: "ITALIE", code: "IT" },
    { id: "039", label: "SUISSE", code: "CH" },
    { id: "011", label: "ESPAGNE", code: "ES" },
    { id: "400", label: "ETATS-UNIS", code: "US" },
    { id: "032", label: "FINLANDE", code: "FI" },
    { id: "030", label: "SUEDE", code: "SE" },
    { id: "038", label: "AUTRICHE", code: "AT" },
    { id: "404", label: "CANADA", code: "CA" },
    { id: "028", label: "NORVEGE", code: "NO" },
    { id: "060", label: "POLOGNE", code: "PL" },
    { id: "248", label: "SENEGAL", code: "SN" },
    { id: "008", label: "DANEMARK", code: "DK" },
    { id: "064", label: "HONGRIE", code: "HU" },
    { id: "800", label: "AUSTRALIE", code: "AU" },
    { id: "068", label: "BULGARIE", code: "BG" },
    { id: "061", label: "REPUBLIQUE TCHEQUE", code: "CZ" },
    { id: "063", label: "SLOVAQUIE", code: "SK" },
    { id: "732", label: "JAPON", code: "JP" },
    { id: "804", label: "NOUVELLE ZELANDE", code: "NZ" },
    { id: "010", label: "PORTUGAL", code: "PT" },
    { id: "204", label: "MAROC", code: "MA" },
    { id: "092", label: "CROATIE", code: "HR" },
    { id: "066", label: "ROUMANIE", code: "RO" },
    { id: "524", label: "URUGUAY", code: "UY" },
    { id: "009", label: "GRECE", code: "GR" },
    { id: "600", label: "CHYPRE", code: "CY" },
    { id: "053", label: "ESTONIE", code: "EE" },
    { id: "054", label: "LETTONIE", code: "LV" },
    { id: "055", label: "LITUANIE", code: "LT" },
    { id: "046", label: "MALTE", code: "MT" },
    { id: "091", label: "SLOVENIE", code: "SI" },
    { id: "632", label: "ARABIE SAOUDITE", code: "SA" },
    { id: "024", label: "ISLANDE", code: "IS" },
    { id: "037", label: "LIECHTENSTEIN", code: "LI" },
    { id: "469", label: "ILES BARBADES", code: "BB" },
    { id: "720", label: "CHINE", code: "CN" },
    { id: "047", label: "SAN MARIN", code: "SM" },
    { id: "076", label: "GEORGIE", code: "GE" },
    { id: "528", label: "ARGENTINE", code: "AR" },
    { id: "272", label: "COTE D'IVOIRE", code: "CI" },
    { id: "740", label: "HONG KONG", code: "HK" },
    { id: "370", label: "MADAGASCAR", code: "MG" },
    { id: "006", label: "ROYAUME-UNI", code: "GB" }
];
